"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILTER_DURATION_FACTOR = 0.8;
/**
 * The frame counter tracks frame rates of video and segmentation.
 */

/** @internal */

var BackgroundFilterFrameCounter = /*#__PURE__*/function () {
  function BackgroundFilterFrameCounter(delegate, reportingPeriodMillis, filterCPUUtilization, logger) {
    _classCallCheck(this, BackgroundFilterFrameCounter);

    this.delegate = delegate;
    this.reportingPeriodMillis = reportingPeriodMillis;
    this.filterCPUUtilization = filterCPUUtilization;
    this.logger = logger;
    this._processingFilter = true;
    this.lastReportedEventTimestamp = 0;
    this.lastFilterCompleteTimestamp = 0;
    this.filterTotalMillis = 0;
    this.filterCount = 0;
    this.framerate = 0;
    this.filterDurationNotifyMillis = 0;
    this.setSegmentationDuration();
  }
  /**
   * Report events once per period.
   */


  _createClass(BackgroundFilterFrameCounter, [{
    key: "reportEvent",
    value: function reportEvent(timestamp) {
      var timeDiff = timestamp - this.lastReportedEventTimestamp;

      if (timeDiff >= this.reportingPeriodMillis) {
        var currentFilterCount = this.filterCount;
        var currentFilterTotalMillis = this.filterTotalMillis;
        this.filterCount = 0;
        this.filterTotalMillis = 0;
        this.lastReportedEventTimestamp = timestamp; // Do not send notification unless a valid framerate or segment count is set.

        if (this.framerate === 0 || currentFilterCount === 0) {
          return;
        }

        var avgFilterDurationMillis = Math.round(currentFilterTotalMillis / currentFilterCount);
        var framesDropped = Math.round(this.framerate * (timeDiff / 1000)) - currentFilterCount;
        var cpuUtilization = Math.round(100 * currentFilterTotalMillis / timeDiff);

        if (avgFilterDurationMillis >= this.filterDurationNotifyMillis) {
          this.delegate.filterFrameDurationHigh({
            framesDropped: framesDropped,
            avgFilterDurationMillis: avgFilterDurationMillis,
            framerate: this.framerate,
            periodMillis: timeDiff
          });
        }

        if (cpuUtilization >= this.filterCPUUtilization) {
          this.delegate.filterCPUUtilizationHigh({
            cpuUtilization: cpuUtilization,
            filterMillis: currentFilterTotalMillis,
            periodMillis: timeDiff
          });
        }
      }
    }
  }, {
    key: "setSegmentationDuration",
    value: function setSegmentationDuration() {
      // allow filtering to take up to 80% of the expected frame duration
      this.filterDurationNotifyMillis = Math.round(1000 / this.framerate * FILTER_DURATION_FACTOR);
    }
  }, {
    key: "frameReceived",
    value: function frameReceived(framerate) {
      if (framerate !== this.framerate) {
        this.framerate = framerate;
        this.logger.info("frame counter setting frame rate to ".concat(this.framerate));
        this.setSegmentationDuration();
      }

      var timestamp = Date.now();
      this.reportEvent(timestamp);
    }
  }, {
    key: "filterSubmitted",
    value: function filterSubmitted() {
      this._processingFilter = true;
      this.lastFilterCompleteTimestamp = Date.now();
    }
  }, {
    key: "filterComplete",
    value: function filterComplete() {
      this.filterTotalMillis += Date.now() - this.lastFilterCompleteTimestamp;
      this._processingFilter = false;
      this.filterCount++;
    }
  }, {
    key: "processingSegment",
    get: function get() {
      return this._processingFilter;
    }
  }]);

  return BackgroundFilterFrameCounter;
}();

exports.default = BackgroundFilterFrameCounter;